import { Avatar, Chip, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import LaunchTwoToneIcon from "@mui/icons-material/LaunchTwoTone";
import { numericFormatter } from "react-number-format";
import { STATUS_STYLES } from "../CompanyManagementLayout/CompanyHeader/CompanyHeader.config";
import { emDashWhenEmpty } from "../../Tools/GridSortUtils";

const emDash = (params: { value?: any }) => emDashWhenEmpty(params.value);

// Headers sort server-side (ascending on first click, blanks last); the
// action columns do not sort (P.8).
export const columns: GridColDef[] = [
  {
    field: "companyName",
    headerName: "Company Name",
    editable: false,
    width: 200,
  },
  {
    field: "salesTotalValue",
    headerName: "Sales Pipeline Value",
    editable: false,
    width: 140,
    valueFormatter(params) {
      if (params.value == null) return "—";
      return numericFormatter(`${params.value}`, {
        thousandSeparator: true,
        decimalScale: 2,
        fixedDecimalScale: true,
        prefix: "$",
      });
    },
  },
  {
    field: "franchiseName",
    headerName: "TDDA Supporting Region",
    editable: false,
    width: 185,
    valueFormatter: emDash,
  },
  {
    field: "tddaRelationshipManager",
    headerName: "TDDA Relationship Manager",
    editable: false,
    width: 220,
    valueFormatter: emDash,
  },
  {
    field: "inProgressActions",
    headerName: "In Progress Action",
    editable: false,
    width: 130,
    renderCell: (params) => (
      <Avatar
        sx={{
          backgroundColor: params.value > 0 && "orange",
        }}
      >
        {params.value}
      </Avatar>
    ),
  },
  {
    field: "overdueActions",
    headerName: "Overdue Action",
    editable: false,
    width: 110,
    renderCell: (params) => (
      <Avatar
        sx={{
          backgroundColor: params.value > 0 && "red",
        }}
      >
        {params.value}
      </Avatar>
    ),
  },
  {
    field: "companyIntegrationStatus",
    headerName: "Imperans Integration",
    editable: false,
    width: 145,
    valueFormatter: emDash,
  },
  {
    field: "dealStage",
    headerName: "Deal Stage",
    editable: false,
    width: 145,
    // Derived summary text ("N Deals in Progress") — not a sortable value.
    sortable: false,
    valueFormatter: emDash,
  },
  {
    field: "status",
    headerName: "Status",
    editable: false,
    width: 102,
    // renderCell: (params) => {
    //   if (!params.value) return "—";
    //   const styles =
    //     STATUS_STYLES[`${params.value}`.toLowerCase()] ||
    //     STATUS_STYLES["default"];
    //   return (
    //     <Chip
    //       label={params.value}
    //       size="small"
    //       sx={{
    //         backgroundColor: styles.chipBg,
    //         color: styles.chipColor,
    //         fontWeight: 600,
    //       }}
    //     />
    //   );
    // },
  },
  {
    field: "lastModifiedBy",
    headerName: "Modified By",
    editable: false,
    width: 150,
    valueFormatter: emDash,
  },
  {
    field: "createdOn",
    headerName: "Created On",
    editable: false,
    width: 95,
    valueFormatter: emDash,
  },
  {
    field: "updatedOn",
    headerName: "Updated On",
    editable: false,
    width: 95,
    valueFormatter: emDash,
  },
  {
    field: "action",
    headerName: "Edit",
    editable: false,
    width: 70,
    sortable: false,
    renderCell: (params) => (
      <IconButton color="primary" component={Link} to={`/company/${params.id}/details`}>
        <EditTwoToneIcon />
      </IconButton>
    ),
  },
  {
    field: "edit",
    headerName: "Overview",
    editable: false,
    width: 100,
    sortable: false,
    renderCell: (params) => (
      <IconButton color="primary" component={Link} to={`/company/${params.id}/overview`}>
        <LaunchTwoToneIcon />
      </IconButton>
    ),
  },
];
